import { render } from "./PersonalityType.vue?vue&type=template&id=774fbf3d&scoped=true"
import script from "./PersonalityType.vue?vue&type=script&lang=js"
export * from "./PersonalityType.vue?vue&type=script&lang=js"

import "./PersonalityType.vue?vue&type=style&index=0&id=774fbf3d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774fbf3d"]])

export default __exports__